import storage_environment_config from "@/components/StorageEnvironment/config";

export default {
  singleLabel: "Zone de stockage",
  storeNamespace: 'storage_zone',
  authFeature: 'storage-zone',
  listRouteName: "StorageZoneList",
  newRouteName: "StorageZoneNew",
  editRouteName: "StorageZoneEdit",
  detailRouteName: "StorageZoneDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'StorageZoneForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'name',
  sortBy: 'name',
  showExtendedFilters: true,
  fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      name: 'warehouse_id',
      label: "Entrepôt",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
    },
    {
      name: 'warehouse',
      label: "Entrepôt",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      extendedFilter: true,
      inDetail: true,
      detailLink: 'WarehouseDetail',
      formatter: (context, value) => value && value.name ? [value.internal_code, value.name].filter(Boolean).join(' - ') : null
    },
    {
      name: 'internal_code',
      label: "Code interne",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'storage_environments',
      label: "Environnements de stockage",
      type: 'list',
      icone: 'warehouse',
      config: storage_environment_config,
      fields: ['name', 'storage_type', 'internal_code']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/StorageZone/config.js